import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  INPUT_IMAGE_ROLE,
  MAX_IMAGE_STYLES,
  OUTPUT_PURPOSES,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.FLUX_TEXT_TO_IMAGE_FLUX2_PRO,
  "provider": PROVIDER.FLUX,
  "action": IMAGE_ACTION.TEXT_TO_IMAGE,
  "mode": IMAGE_MODE.FLUX2_PRO,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      "output_purpose": {
        "type": "string",
        "enum": OUTPUT_PURPOSES,
      },
      // Style references only: there is no object image, so the prompt alone decides
      // what is shown and the presets set the look. Left out entirely when none is picked.
      "input_image": {
        "type": "array",
        "minItems": 0,
        "maxItems": MAX_IMAGE_STYLES,
        "items": {
          "type": "object",
          "properties": {
            "asset_id": { "type": "integer" },
            "role": { "type": "string", "enum": [INPUT_IMAGE_ROLE.STYLE] },
          },
          "required": ["asset_id", "role"],
        },
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt"],
  },
  "ui_schema": {},
}
